import { apiFetch, getToken } from './storage';
import type { Order } from './types';

export async function autoSelectFirstLyrics(order: Order): Promise<void> {
  const first = order.lyricsOptions?.[0]?.lyrics?.trim();
  if (!first) {
    throw new Error('lyrics_unavailable');
  }

  const token = getToken(order.slug);
  const response = await fetch(apiFetch('select-lyrics'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ slug: order.slug, lyrics_index: 0, lyrics: first }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || !data.ok) {
    throw new Error(data.error || 'select_lyrics_failed');
  }
}
